import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonCountryHeroComponent } from 'src/app/shared/components/countryHero/hero.component';
import { LocalTrustedWaySectionComponent } from './trusted-way-section/trusted-way-section.component';
import { FeaturesSectionComponent } from './features/features.component';
import { UnifiedSolutionsComponent } from './unified-solutions/unified-solutions.component';
import { CommonSubProductsWhitePaperComponent } from 'src/app/shared/components/sub-products/white-paper/white-paper.component';
import { CommonGetstartedComponent } from 'src/app/shared/components/getstarted/getstarted.component';
import { CommonModule } from '@angular/common';
import { PosthogService } from 'src/app/shared/services/posthog.service';
import { CommonDiscoverWhyComponent } from 'src/app/shared/components/discover-why/discover-why.component';
@Component({
  selector: 'app-countryhome',
  templateUrl: './countryhome.component.html',
  styleUrls: ['./countryhome.component.scss'],
  imports: [
    CommonModule,
    CommonCountryHeroComponent,
    LocalTrustedWaySectionComponent,
    UnifiedSolutionsComponent,
    FeaturesSectionComponent,
    CommonSubProductsWhitePaperComponent,
    CommonGetstartedComponent,
    CommonDiscoverWhyComponent
  ],
})
export class CountryHomeComponent implements OnInit {
  heroHeader: any;
  logosData: any;
  countryName: string = '';
  newsList: any;
  getStartedData?: any;
  pageData: any;
  whitePaperData: any;
  discoverData: any;
  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly posthogService: PosthogService
  ) {}

  ngOnInit(): void {
    const data = this.route.snapshot.data['seo'][0].fields;
    this.pageData = this.route.snapshot.data['seo'][0].fields;
    if (data) {
      this.pageData = data;
      const heroData = data?.heroContentPanel?.fields;
      this.whitePaperData = this.pageData?.whitepaperAndReportsArticle?.fields;
      const getStartedData = this.pageData?.getStartedContentPanel?.fields;
      if (this.pageData?.useCase) {
        this.discoverData = this.pageData?.useCase?.fields;
      }
      if (heroData != null) {
        this.heroHeader = {
          tagName: heroData?.tags?.[0]?.fields?.tagText,
          tagIcon: heroData?.tags?.[0]?.fields?.icon?.fields?.file?.url,
          header: heroData?.title,
          image: heroData?.image[0].fields,
          paragraph: heroData?.content,
          button1: {
            text: heroData?.buttons?.[0]?.fields?.buttonText,
            url: heroData?.buttons?.[0]?.fields?.redirectLink,
            target: heroData?.buttons?.[0]?.fields?.actionType,
          },
          button2: {
            text: heroData?.buttons?.[1]?.fields?.buttonText,
            url: heroData?.buttons?.[1]?.fields?.redirectLink,
            target: heroData?.buttons?.[1]?.fields?.actionType,
          },
        };
      }
      if (getStartedData != null) {
        this.getStartedData = {
          header: getStartedData?.title,
          button1: {
            url: getStartedData?.buttons[0].fields.redirectLink,
            text: getStartedData?.buttons[0].fields.buttonText,
            target: getStartedData?.buttons[0].fields.actionType,
          },
          button2: {
            url: getStartedData?.buttons[1].fields.redirectLink,
            text: getStartedData?.buttons[1].fields.buttonText,
            target: getStartedData?.buttons[1].fields.actionType,
          },
        };
      }
    }
    const url = this.router.url;
    const countryMatch = /\/country\/([^/?]+)/.exec(url);
    const countryName = countryMatch ? countryMatch[1] : 'uk';
    this.posthogService.capturePageViewEvent(countryName);
  }
}
